module.exports = __webpack_public_path__ + "static/media/klášter-vánoce2000-5.f498e628.jpg";